import { Renderer2 } from '@angular/core';
import { ReplaySubject } from 'rxjs';

// inject(Renderer2)
// inject(WINDOW) -> window.document
export function scriptLoader(renderer: Renderer2, document: Document) {
  return (src: string) => {
    const script$ = new ReplaySubject<HTMLScriptElement>();
    const notify = (scriptEl: HTMLScriptElement) => {
      script$.next(scriptEl);
      script$.complete();
    };

    const found = document.querySelector(`script[src="${src}"]`) as HTMLScriptElement;
    if (found) {
      notify(found);
      return script$;
    }

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = src;
    renderer.appendChild(document.head, script);

    script.onload = () => {
      notify(script);
    };

    return script$;
  };
}
